import {Subject} from "rxjs";
import {BackendService} from "../backend.service";

//this class triggers checks if food search and backend services are reachable, and also check if an endpoint is reachable which requires authentication.
//in case both normal endpoints are reachable but the autenthicated ones are not, a re-login probably makes sense
export class ReLoginCheck {

  public reLoginRecommended: boolean = false;
  public finishedSubject: Subject<boolean> = new Subject<boolean>();
  private foodSearchResult: boolean;
  private foodSearchResultAvailable: boolean = false;
  private foodSearchAuthResult: boolean;
  private foodSearchAuthResultAvailable: boolean = false;
  private backendResult: boolean;
  private backendResultAvailable: boolean = false;
  private backendAuthResult: boolean;
  private backendAuthResultAvailable: boolean = false;

  constructor(private backend: BackendService) {
    this.test();
  }

  private async test(): Promise<void> {
    var sub1 = this.backend.foodSearchOnline().subscribe({
      next: result => {
        this.foodSearchResult = result.body;
        this.foodSearchResultAvailable = true;
        this.checkFinished();
        sub1.unsubscribe();
      },
      error: () => {
        this.foodSearchResult = false;
        this.foodSearchResultAvailable = true;
        this.checkFinished();
        sub1.unsubscribe();
      }
    });
    var sub2 = this.backend.backendOnline().subscribe({
      next: result => {
        this.backendResult = result.body;
        this.backendResultAvailable = true;
        this.checkFinished();
        sub2.unsubscribe();
      },
      error: () => {
        this.backendResult = false;
        this.backendResultAvailable = true;
        this.checkFinished();
        sub2.unsubscribe();
      }
    });
    var sub3 = (await this.backend.foodSearchOnlineAuth()).subscribe({
      next: result => {
        this.foodSearchAuthResult = result.body;
        this.foodSearchAuthResultAvailable = true;
        this.checkFinished();
        sub3.unsubscribe();
      },
      error: () => {
        this.foodSearchAuthResult = false;
        this.foodSearchAuthResultAvailable = true;
        this.checkFinished();
        sub3.unsubscribe();
      }
    });
    var sub4 = (await this.backend.backendOnlineAuth()).subscribe({
      next: result => {
        this.backendAuthResult = result.body;
        this.backendAuthResultAvailable = true;
        this.checkFinished();
        sub4.unsubscribe();
      },
      error: () => {
        this.backendAuthResult = false;
        this.backendAuthResultAvailable = true;
        this.checkFinished();
        sub4.unsubscribe();
      }
    });
  }

  private checkFinished(): void {
    if (!this.foodSearchResultAvailable || !this.backendResultAvailable || !this.foodSearchAuthResultAvailable || !this.backendAuthResultAvailable) return;
    if (this.foodSearchResult && this.backendResult && !this.foodSearchAuthResult && !this.backendAuthResult) this.reLoginRecommended = true;
    this.finishedSubject.next(true);
  }
}
